"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../utils");
var Checkbox_styled_1 = __importDefault(require("./Checkbox.styled"));
function Checkbox(_a) {
    var onChange = _a.onChange, name = _a.name, checked = _a.checked, label = _a.label, className = _a.className;
    var uniqueId = utils_1.generateUniqueId();
    return (react_1.default.createElement(Checkbox_styled_1.default, { className: className },
        react_1.default.createElement("input", { type: "checkbox", name: name + "-" + uniqueId, checked: checked, id: uniqueId, onChange: function (e) {
                return onChange(e, name);
            } }),
        react_1.default.createElement("label", { htmlFor: uniqueId }, label)));
}
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map